import { useState } from 'react';
import Image from 'next/image';
import { Typography } from '@mui/material';
import NoPersonalData from '@/images/animations/no_personal_data.gif';
import DashboardSectionContainer from '@/views/appstore/dashboard/components/DashboardSectionContainer';
import SetAppStoreButton from '@/views/appstore/dashboard/components/SetAppStoreButton';

const GoToJoinAppStorePostsCareService = ({ isMobile }: { isMobile: boolean }) => {
  const [showSearchModal, setShowSearchModal] = useState(true);

  return (
    <>
      <DashboardSectionContainer isMobile={isMobile}>
        <>
          <Image src={NoPersonalData.src} width={200} height={200} alt="병원없음" />
          <Typography variant="subtitle2" textAlign="center" marginBottom={'32px'}>
            아직 병원이 설정되지 않았습니다.
            <br />
            리뷰를 관리하고 싶은 병원을 설정해 주세요.
          </Typography>
          <SetAppStoreButton showSearchModal={showSearchModal} setShowSearchModal={setShowSearchModal} />
        </>
      </DashboardSectionContainer>
    </>
  );
};

export default GoToJoinAppStorePostsCareService;
